import _ from "lodash";
import React, { useContext } from "react";
import sitemap from "../data/sitemap.json";
import { useAuth } from "react-oidc-context";
import { useFetchDelegatedUsersQuery } from "../services/identity";

const NavigationContext = React.createContext();

export const useNavigationContext = () => useContext(NavigationContext);

export const NavigationProvider = ({ children }) => {
    const auth = useAuth();
    const { data: delegatedUsers } = useFetchDelegatedUsersQuery({ accessType: null });
    const { user: { profile } } = auth;
    const isSuperUser = _.some(profile.groups, e => ['Super User'].includes(e))
    const adviserRole = ["advisers"];
    const checkForAdviserRole = _.some(profile.roles, item => adviserRole.includes(item));
    const isNotAdviserOrSuperUser = (checkForAdviserRole === false && isSuperUser === false);
    const isAdviser = checkForAdviserRole === true;
    const hasDelegateAccess = (isNotAdviserOrSuperUser === true && delegatedUsers?.length > 1)
    const hasAdviserDashboardAccess = (isAdviser || isSuperUser || hasDelegateAccess)

    const mySiteMap = React.useMemo(() => {
        //order the site map by the display order
        sitemap.data = sitemap.data.sort((a, b) => a.displayOrder - b.displayOrder);

        return sitemap.data.filter(item => {
            if (!item.isActive) return false;
            const hasRequiredRole = !item.requiredRoles || item.requiredRoles.length === 0 || _.some(profile.roles, role => item.requiredRoles.includes(role));
            const adviserDashboardVisible = !item.adviserDashboardAccess || hasAdviserDashboardAccess;
            return hasRequiredRole && adviserDashboardVisible;
        });
    }, [profile.roles, sitemap, hasDelegateAccess, isAdviser, isSuperUser]);

    return <NavigationContext.Provider value={{
        navigation: mySiteMap
    }}>
        {children}
    </NavigationContext.Provider>
};